/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonitoringTubeOverview
 */
export interface MonitoringTubeOverview {
  /**
   *
   * @type {string}
   * @memberof MonitoringTubeOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof MonitoringTubeOverview
   */
  tubeNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoringTubeOverview
   */
  tubeStatus?: string | null;
}

/**
 * Check if a given object implements the MonitoringTubeOverview interface.
 */
export function instanceOfMonitoringTubeOverview(value: object): value is MonitoringTubeOverview {
  return true;
}

export function MonitoringTubeOverviewFromJSON(json: any): MonitoringTubeOverview {
  return MonitoringTubeOverviewFromJSONTyped(json, false);
}

export function MonitoringTubeOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonitoringTubeOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    tubeNumber:
      json["tube_number"] === undefined
        ? undefined
        : json["tube_number"] === null
        ? null
        : json["tube_number"],
    tubeStatus:
      json["tube_status"] === undefined
        ? undefined
        : json["tube_status"] === null
        ? null
        : json["tube_status"],
  };
}

export function MonitoringTubeOverviewToJSON(json: any): MonitoringTubeOverview {
  return MonitoringTubeOverviewToJSONTyped(json, false);
}

export function MonitoringTubeOverviewToJSONTyped(
  value?: Omit<MonitoringTubeOverview, "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tube_number: value["tubeNumber"],
    tube_status: value["tubeStatus"],
  };
}
